import wait from '@mailobj-browser/front/js/utils/wait.js'

const { parseInt } = Number

export default ({ content, ownerDocument }) => {
  const [delay, url] = content.split(';url=')
  
  queueMicrotask(async () => {
    await wait(parseInt(delay) * 1000)
    ownerDocument.location.href = url
  })
}
